import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { BannerComponent } from './components/banner/banner.component';
import { ContentComponent } from './components/content/content.component';
import { IdleLoggedOutComponent } from './components/idle-logged-out/idle-logged-out.component';
import { IdleWarningComponent } from './components/idle-warning/idle-warning.component';
import { ModalComponent } from './components/modal/modal.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { ToolbarAdditionalInfoComponent } from './components/toolbar-additional-info/toolbar-additional-info.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { MaintenanceComponent } from './containers/maintenance/maintenance.component';
import { CoreRoutingModule } from './core-routing.module';
import { HttpRequestInterceptor } from './interceptors/http-request-interceptor';
import { LogRocketInterceptor } from './interceptors/log-rocket.interceptor';
import { ReadOnlyInterceptor } from './interceptors/read-only.interceptor';
import { ReadOnlyInfoDialogComponent } from './components/read-only-info-dialog/read-only-info-dialog.component';
import { ExportDataDialogComponent } from './components/export-data-dialog/export-data-dialog.component';
import { AvatarComponent } from '../shared/components/avatar/avatar.component';
import { ContainerComponent } from '../shared/components/container/container.component';

@NgModule({
  declarations: [
    IdleWarningComponent,
    IdleLoggedOutComponent,
    MaintenanceComponent,
    ContentComponent,
    ToolbarComponent,
    ToolbarAdditionalInfoComponent,
    SidenavComponent,
    BannerComponent,
    ModalComponent,
    ReadOnlyInfoDialogComponent,
    ExportDataDialogComponent,
  ],
  imports: [CommonModule, SharedModule, CoreRoutingModule, ReactiveFormsModule, AvatarComponent, ContainerComponent],
  providers: [
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: LogRocketInterceptor,
    },
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
    },
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: ReadOnlyInterceptor,
    },
  ],
  exports: [
    BannerComponent,
  ],
})
export class CoreModule {}
